var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cursor-music" }, [
    _c("audio", {
      ref: `music-preview`,
      attrs: {
        src: (_vm.music.track || _vm.music.original_sound)
          .progressive_download_url,
      },
      on: { canplaythrough: (e) => (e.target.volume = "0.5") },
    }),
    _c("div", { staticClass: "options" }, [
      _c("div", { staticClass: "circle btn-time" }, [
        _vm.durationLock
          ? _c(
              "select",
              { staticClass: "timer-music", attrs: { disabled: "" } },
              [
                _c("option", { attrs: { selected: "" } }, [
                  _vm._v(_vm._s(parseInt(this.models.rangeDuration / 1000))),
                ]),
              ]
            )
          : _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.models.rangeDuration,
                    expression: "models.rangeDuration",
                  },
                ],
                staticClass: "timer-music",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.models,
                        "rangeDuration",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.playMusic,
                  ],
                },
              },
              [
                _c("option", { attrs: { disabled: "" } }, [_vm._v("Secondes")]),
                _vm._l(
                  Array.from(
                    { length: Math.max(0, _vm.maxDurationSec - 4) },
                    (_, i) => i + 5
                  ),
                  function (value) {
                    return _c(
                      "option",
                      { key: value, domProps: { value: value * 1000 } },
                      [_vm._v(_vm._s(value))]
                    )
                  }
                ),
              ],
              2
            ),
      ]),
      _c(
        "div",
        {
          staticClass: "container-line",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.clickLine.apply(null, arguments)
            },
          },
        },
        [
          _vm._l(
            _vm.music.track ? _vm.music.track.highlight_start_times_in_ms : [],
            function (time) {
              return _c("div", {
                staticClass: "repair",
                style: {
                  left: `${
                    (time /
                      (_vm.music.track || _vm.musics.original_sound)
                        .duration_in_ms) *
                    100
                  }%`,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.clickRepair(time)
                  },
                },
              })
            }
          ),
          _c("div", {
            staticClass: "range",
            style: {
              width: `${
                (parseInt(_vm.rangeDuration) /
                  (_vm.music.track || _vm.musics.original_sound)
                    .duration_in_ms) *
                100
              }%`,
              left: `${
                (_vm.models.start /
                  (_vm.music.track || _vm.music.original_sound)
                    .duration_in_ms) *
                100
              }%`,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          }),
        ],
        2
      ),
      _c("div", {
        staticClass: "circle btn-play",
        class: { playing: _vm.isPlaying },
        on: { click: _vm.toggleMusic },
      }),
    ]),
    _c("div", { staticClass: "timeline" }, [
      _c("div", { staticClass: "box" }, [
        _c("div", {
          staticClass: "progress",
          style:
            _vm.isPlaying && _vm.duration >= 0
              ? `width: ${
                  100 - (_vm.duration / parseInt(_vm.rangeDuration)) * 100
                }%;`
              : "",
        }),
      ]),
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "bars hide-scrollbar",
          on: {
            mousedown: _vm.startDrag,
            mousemove: _vm.onDrag,
            mouseup: _vm.stopDrag,
            mouseleave: _vm.stopDrag,
            scroll: _vm.handleScroll,
          },
        },
        _vm._l(
          Array.from({
            length: parseInt(
              (_vm.music.track || _vm.musics.original_sound).duration_in_ms /
                1000
            ),
          }),
          function (bar, index) {
            return _c("div", {
              staticClass: "bar",
              class: { high: index % 2 == 0 },
            })
          }
        ),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }